import { normalizeRoutingLoadId } from "./routingStatusStrideAdapter";

export const shouldCarryForwardUnmatchedHistoryRow = (
  historyLoadId,
  incomingLoadIds = []
) => {
  if (normalizeRoutingLoadId(historyLoadId) !== "0") return true;

  const normalizedIncomingLoads = new Set(
    Array.from(incomingLoadIds || [], (value) => normalizeRoutingLoadId(value))
  );

  return normalizedIncomingLoads.size === 0 || normalizedIncomingLoads.has("0");
};
